import { HttpClient } from 'core/common/services';
import { ContentData, ContentManagerService } from './ContentManager';

export class ContentManagerClientService implements ContentManagerService {
  constructor(private readonly httpClient: HttpClient) {}

  async getContent(url: string): Promise<ContentData> {
    const response = await this.httpClient.get<ContentData>(url, {
      headers: {},
      withCredentials: false,
    });

    return response;
  }
}
